"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var TextField_1 = __importDefault(require("../../TextField"));
var Button_1 = __importDefault(require("../../Button"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {},
        textarea: {
            marginTop: theme.spacing(1),
            padding: theme.spacing(1),
        },
        formControl: {
            marginTop: theme.spacing(2),
        },
        fileButton: {
            position: 'relative',
            marginTop: theme.spacing(1),
        },
        fileInput: {
            cursor: 'pointer',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            opacity: 0,
        },
    });
});
var DeckImportFromCsv = function (_a) {
    var classNameProp = _a.className, onFieldChange = _a.onFieldChange, onFileChange = _a.onFileChange, filename = _a.filename, values = _a.values, other = __rest(_a, ["className", "onFieldChange", "onFileChange", "filename", "values"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(core_1.FormHelperText, null,
            "You can import up to 200 cards at a time. Please ensure that the values in your CSV file are in the following order (values in bold are required):",
            react_1.default.createElement("br", null),
            react_1.default.createElement("strong", null, "question"),
            ", ",
            react_1.default.createElement("strong", null, "answer"),
            ", explanation, summary"),
        react_1.default.createElement(core_1.FormControl, { fullWidth: true, className: classes.formControl },
            react_1.default.createElement(core_1.FormLabel, { component: "legend" }, "Import from a CSV file"),
            react_1.default.createElement(Button_1.default, { variant: "flat", color: "primary", className: classes.fileButton },
                filename || 'Select a File',
                react_1.default.createElement("input", { type: "file", name: "file", id: "csv-file-input", onChange: onFileChange, className: classes.fileInput, accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .txt" }))),
        react_1.default.createElement(core_1.FormControl, { fullWidth: true, className: classes.formControl },
            react_1.default.createElement(core_1.FormLabel, { component: "legend" }, "Or paste CSV content below"),
            react_1.default.createElement(TextField_1.default, { multiline: true, rows: 6, variant: "bordered", name: "text", id: "text-input", value: values.text, onChange: onFieldChange, InputBaseProps: {
                    className: classes.textarea,
                } }))));
};
exports.default = DeckImportFromCsv;
//# sourceMappingURL=DeckImportFromCsv.js.map